import ApplicationController from './application_controller'

// Single page-level share dialog. Each lot's Share button passes its data
// (title, sku, widget url) as action params; the email form is submitted with
// fetch so the user never leaves the catalog page.
export default class extends ApplicationController {
  static targets = ['dialog', 'title', 'link', 'sku', 'form', 'error', 'toast']

  open ({ params }) {
    this.titleTarget.textContent = params.title
    this.linkTarget.value = params.widgetUrl
    this.skuTarget.value = params.sku
    this.errorTarget.hidden = true
    this.dialogTarget.showModal()
  }

  close () {
    this.dialogTarget.close()
  }

  async submit (event) {
    event.preventDefault()

    const response = await fetch(this.formTarget.action, {
      method: 'POST',
      body: new FormData(this.formTarget),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })

    if (response.ok) {
      this.formTarget.reset()
      this.close()
      this.#flashToast()
    } else {
      this.errorTarget.hidden = false
    }
  }

  #flashToast () {
    this.toastTarget.hidden = false
    setTimeout(() => { this.toastTarget.hidden = true }, 3000)
  }
}
